import {Injectable} from '@angular/core';
import {ModalController} from '@ionic/angular';
import {AuthService} from './auth.service';
import {StorageService} from '../storage/storage.service';
import {LocationService} from '../core/location.service';
import {StoreService} from '../customer/store.service';
import {DeliveryAreaLocationModalPage} from '../../modals/delivery-area-location-modal/delivery-area-location-modal.page';
import {GeoLocation} from '../../types/interfaces';
import {LeafletCoordinate} from '../../types/thirdparty';
import {DeliveryType} from '../../types/enums';

@Injectable({
  providedIn: 'root'
})
export class DeliveryAreaLocationService {

  private readonly hasCheckedKey = 'has-checked-delivery-area-location';
  private checking = false;

  constructor(
    private authService: AuthService,
    private storageService: StorageService,
    private locationService: LocationService,
    private storeService: StoreService,
    private modalController: ModalController,
  ) {
  }

  init() {
    this.authService.LoggedIn.subscribe(async () => this.check());
  }

  async check() {
    if (this.checking) {
      return;
    }
    this.checking = true;
    try {
      if (await this.storageService.getBoolean(this.hasCheckedKey)) {
        return;
      }
      await this.storageService.saveBoolean(this.hasCheckedKey, true);
      const location = await this.locationService.loadAndSaveGeoLocation();
      if (!location) {
        return;
      }
      const areas = await this.storeService.getAllDeliveryAreasForMap();
      const matchedArea = this.storeService.findMatchingDeliveryArea(areas, location);
      await this.openDeliveryAreaLocationModal(location, matchedArea, areas);
    } finally {
      this.checking = false;
    }
  }

  private async openDeliveryAreaLocationModal(
    location: GeoLocation,
    matchedArea: { coordinate: LeafletCoordinate; options: any, styleName: string, deliveryType: DeliveryType },
    areas: { coordinate: LeafletCoordinate; options: any, styleName: string, deliveryType: DeliveryType }[]
  ) {
    const modal = await this.modalController.create({
      component: DeliveryAreaLocationModalPage,
      componentProps: {
        Location: location,
        MatchedArea: matchedArea,
        Areas: areas
      },
      cssClass: 'height-75 space-around',
      backdropDismiss: false,
    });
    await modal.present();
    await modal.onDidDismiss();
  }
}
